module.exports = __webpack_public_path__ + "img/2.cbbbff0b.png";